import { useRouter } from 'vue-router'
import { useApi } from '@/functions/api'
import { useAuthStore } from '@/stores/auth'

export function useLogout () {
  const router = useRouter()
  const auth = useAuthStore()
  const api = useApi()

  return () => {
    api.POST('logout')
    router.push({ name: 'login' })
    auth.$reset()
    auth.setAuthenticated(0)
  }
}
